/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios'
import httpFilter from '@/common/js/httpFilter'

const AJAX = axios.create({
  baseURL: `//${globalConfig.linkPath}/yunjispecialbuyer`,
  withCredentials: true
})
httpFilter(AJAX)
export default AJAX
